import { useState } from "react";
import clsx from 'clsx'
import { DefaultTitle } from "../../../_metronic/layout/components/header/page-title/DefaultTitle";
import { PageTitle, useLayout } from "../../../_metronic/layout/core";
import { IImportar } from "../../interfaces/IImportar";
import ImportarNovoModal from "./ImportarNovoModal";
import Swal from 'sweetalert2';
import VerticalLinearStepper from "./VerticalLinearStepper";

const ImportarNovo = () => {
    const { classes } = useLayout();
    const [showModal, setShowModal] = useState<boolean>(false);
    const [eventoVM, setEventoVM] = useState<IImportar>({} as IImportar);
    const [modalTitle, setModalTitle] = useState<'Empresa'>('Empresa');
    const [formularioCalendario, setFormularioCalendario] = useState<File[]>([]);
    // const [activeStep, setActiveStep] = useState<number>(0);

    // const handleNext = () => {
    //     setActiveStep((prevActiveStep) => prevActiveStep + 1);
    // };

    // const handleBack = () => {
    //     setActiveStep((prevActiveStep) => prevActiveStep - 1);
    // };

    // const handleReset = () => {
    //     setActiveStep(0);
    // };

    async function salvar(empresa: IImportar) {
        toggleModal();
        await Swal.fire({
            text: 'Empresa foi adicionada com sucesso',
            timer: 4000,
            icon: 'success',
            showConfirmButton: false
        });
    }

    function toggleModal(): void {
        let show = !showModal;

        setShowModal(show);

        if (show === false) {
            setTimeout(() => { setEventoVM({} as IImportar) }, 300)
        }
    }
    
    return <>
        <PageTitle breadcrumbs={[]}>Importar arquivos</PageTitle>
        <div className='toolbar' id='kt_toolbar'>
            <div id='kt_toolbar_container' className={clsx(classes.toolbarContainer.join(' '), 'd-flex flex-stack')}>
                <DefaultTitle />
            </div>
        </div>
        <div className="col-md-12" style={{ display: 'flex' }}>
            <div className="col-md-3">
                <label style={{ fontSize: '14px', color: '#aaa' }}>Razão Social</label>
                <h3>LFUTURO DO BRASIL S.A.</h3>
                <label style={{ fontSize: '14px', color: '#aaa' }}>CNPJ</label>
                <h3>16.457.056/0001-00</h3>
                <label style={{ fontSize: '14px', color: '#aaa' }}>Regime Tributário</label>
                <h3>Simples Nacional</h3>

                <ImportarNovoModal salvar={salvar} importar={eventoVM} title={modalTitle} show={showModal} toggleModal={toggleModal} />
                <div style={{ cursor: 'pointer', borderRadius: '10px', border: '2px solid #eda12f', backgroundColor: '#f2dba0', marginTop: '20px', padding: '15px 0 10px 40px', maxWidth: '250px' }} onClick={() => {
                    setModalTitle('Empresa');
                    setEventoVM({} as IImportar);
                    setShowModal(true);
                }}>
                    <h3 style={{ color: '#ed9715' }}>Cadastro incompleto.</h3>
                    <label style={{ paddingLeft: '10px', color: '#eda12f' }}>Deseja continuar agora?</label>
                </div>
            </div>
            <div className="col-md-6">
                <div style={{ display: 'grid' }}>
                    <label htmlFor="file" style={{ fontWeight: 600 }}>NF Serviços Prestados - Dentro do munícipio</label>
                    <progress id="file" value="20" max="100" />
                </div>
                <div style={{ overflow: 'auto', maxHeight: '195px', maxWidth: '600px' }}>
                    {
                        formularioCalendario.map(arquivo => {
                            return <div style={{ border: '1px solid #ccc', borderRadius: '3px', margin: '3px 0', padding: '5px', width: '600px' }}>
                                <i className="bi bi-file-earmark-text fa-lg" style={{ color: '#00B7A1' }}></i>
                                <span className="azul-agriholmes" style={{ fontFamily: 'Cairo', fontSize: '16px' }}> {arquivo?.name}</span>
                                <i className="bi bi-x-circle fa-lg" style={{ float: 'right', margin: '4px 4px 0 0', color: 'black', cursor: 'pointer' }} onClick={() => setFormularioCalendario([...formularioCalendario.filter(x => x !== arquivo)])}></i>
                            </div>
                        })
                    }
                </div>
                <input style={{ display: 'none' }} id="inputFile" type="file" onChange={e => {
                    if (e.target.files !== null && e.target.files.length > 0) {
                        const file = e.target.files[0];
                        setFormularioCalendario(array => [...array, file]);
                    }
                }} />
                <div onClick={() => {
                    const input = document.getElementById("inputFile");
                    input?.click();
                }} className="col-md-12 mt-5" style={{ border: '2px dashed #8E92B8', textAlign: 'center', borderRadius: '10px', cursor: 'pointer', height: '150px', width: "600px", paddingTop: '5px' }}>
                    <div className="dropzone " id="upload" >
                        <div className="mt-5 mb-5">
                            <i className="bi bi-cloud-arrow-up fs-5x azul-agriholmes"></i>
                            <span className="azul-agriholmes" style={{ fontFamily: 'Cairo', fontSize: '26px' }}> <br />Importar NF Serviços Prestados</span>
                        </div>
                    </div>
                </div>

                <div style={{ display: 'flex', marginTop: '20px' }}>
                    <button style={{ height: '40px', fontWeight: 800, marginRight: 'auto' }} className='btn btn-sm btn-primario'>RELATÓRIO<i style={{ marginLeft: '10px' }} className="icon-lg text-white bi bi-pie-chart"></i></button>
                    <button style={{ height: '40px', color: '#496D93', backgroundColor: 'white', border: '2px solid #496D93', fontWeight: 800, marginRight: '10px' }} className='btn btn-sm'>PULAR<i style={{ marginLeft: '10px' }} className="azul-agriholmes bi bi-skip-end"></i></button>
                    <button style={{ height: '40px', fontWeight: 800 }} className='btn btn-sm btn-primario'>CONTINUAR<i style={{ marginLeft: '10px' }} className="icon-lg text-white bi bi-arrow-right"/></button>
                </div>
            </div>
            <div className="col-md-3">
                <VerticalLinearStepper activeStep={0    } />
            </div>
        </div>
    </>
};


export default ImportarNovo;